import DigitalSkins from './views/digital-skins.c';
export default DigitalSkins;
